import { MenuItem, Select, Stack } from "@mui/material";
import FlagIcon from "components/icons/FlagIcon";
import i18n from "localization/i18n";
import { useEffect, useState } from "react";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import useIsSmUp from "hooks/useIsSmUp";
import { useThemeColors } from "theme/hooks/useThemeColors";

export default function LanguageSelector({
  stackSx,
  textColor,
  iconColor,
  sx,
  ...props
}: {
  stackSx?: { [s: string]: any };
  textColor?: string;
  iconColor?: string;
  sx?: { [s: string]: any };
  [s: string]: any;
}) {
  const [lang, setLang] = useState(i18n.language);
  const colors = useThemeColors();

  /**
   * NOTE for E2E: this triggers a full `window.location.reload()`, so a spec
   * that switches language must await the navigation before asserting.
   */
  const setLanguage = (language: string) => {
    setLang(language);
    localStorage.setItem("localLanguage", language);
    i18n.changeLanguage(language);
    window.location.reload();
  };
  const isSmUp = useIsSmUp();
  useEffect(() => {
    const currentLang = localStorage.getItem("localLanguage");
    if (currentLang === null) {
      const deviceLang = navigator.language;
      setLanguage(deviceLang.split("-")[0]);
    }
  }, []);

  const selectColor = textColor ?? (isSmUp ? colors.brand.primary : "white");
  const arrowColor = iconColor ?? selectColor;

  return (
    <Stack
      direction={"row"}
      spacing={"8px"}
      sx={{
        alignItems: "center",
        mb: 2,
        ...stackSx
      }}>
      <FlagIcon
        code={lang === "en" ? "US" : "EG"}
        width={"20px"}
        height={"13px"}
      />
      <Select
        id="language"
        data-testid="language-selector"
        variant="standard"
        disableUnderline
        value={i18n.language}
        IconComponent={(props) => (
          <KeyboardArrowDownOutlinedIcon
            {...props}
            sx={{
              color: `${arrowColor} !important`,
            }}
          />
        )}
        onChange={(e) => {
          setLanguage(e.target.value);
        }}
        {...props}
        sx={{
          "& .MuiSelect-select": {
            fontSize: "14px",
            fontWeight: 500,
            color: selectColor,
          },
          ...sx,
        }}
      >
        <MenuItem value={"en"} data-testid="language-option-en">
          English
        </MenuItem>
        <MenuItem value={"ar"} data-testid="language-option-ar">
          العربية
        </MenuItem>
      </Select>
    </Stack>
  );
}
